import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ssc-contact-btn',
  templateUrl: './contact-btn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactBtnComponent {
  @Input() public showContactButton = false;

  public showContactOverlay = false;
}
